import { render, staticRenderFns } from "./CT.vue?vue&type=template&id=66c4554b&scoped=true"
import script from "./CT.vue?vue&type=script&lang=js"
export * from "./CT.vue?vue&type=script&lang=js"
import style0 from "./CT.vue?vue&type=style&index=0&id=66c4554b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c4554b",
  null
  
)

export default component.exports